module.exports = __webpack_public_path__ + "5e31e37c1d1b940ddff88db4e04cabf8.pdf";